import React from 'react'
import styles from '../css/TargetTypeLegend.module.css'

// Target type definitions shown above the status bar, per team. Teams without an entry show nothing.
export const TARGET_TYPE_DESCRIPTIONS = {
    '14': [
        { type: 'A',   text: 'High potential HCPs within the BMT centers only' },
        { type: 'B',   text: 'Medium to Low potential HCPs within the BMT centers only' },
        { type: 'COC', text: 'Continuity of Care: HCPs at Non-BMT centers' },
        { type: 'CT',  text: 'Care Team: Non prescribers but high influence within a BMT Center' },
    ],
}

export default function TargetTypeLegend({ team }) {
    const items = TARGET_TYPE_DESCRIPTIONS[String(team ?? '')]
    if (!items) return null

    return (
        <div className={styles.legend} aria-label="Target type definitions">
            {items.map(({ type, text }) => (
                <div key={type} className={styles.item}>
                    <span className={[styles.chip, styles[`chip${type}`]].join(' ')}>{type}</span>
                    <span className={styles.text}>{text}</span>
                </div>
            ))}
        </div>
    )
}
